import { Flame, MapPin } from "lucide-react";

export default function Hero() {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden flex items-end"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: "url('/images/hero.jpg')" }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/30 to-black/40" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-transparent to-transparent" />

      <div className="relative container-wide pb-20 sm:pb-24 lg:pb-28 pt-32 w-full">
        <div className="max-w-3xl text-white">
          <div className="inline-flex items-center gap-2 glass !bg-white/15 border border-white/25 rounded-full px-4 py-2 text-xs sm:text-sm tracking-wide mb-6" data-testid="location-badge">
            <MapPin size={14} className="text-[#E05947]" />
            <span className="text-white/95">Church Lane · Letterkenny</span>
          </div>

          <h1 className="font-serif-display text-5xl sm:text-6xl lg:text-7xl leading-[1.02] mb-6">
            Sit back, breathe, and taste the <em className="italic text-[#E05947] font-medium">Himalayas.</em>
          </h1>

          <p className="text-lg sm:text-xl text-white/85 max-w-2xl mb-9 leading-relaxed">
            More than just a café, it's a place to slow down and enjoy life's simple pleasures.
            From your morning coffee to an evening meal with loved ones, every visit is designed to make you feel welcome.
          </p>

          <div className="flex flex-wrap gap-4 mb-6">
            <button onClick={() => scrollTo("contact")} data-testid="hero-book-button" className="btn-primary">
              Book a Table
            </button>
            <button onClick={() => scrollTo("menu")} data-testid="hero-menu-button" className="btn-ghost-light">
              View Menu
            </button>
          </div>

          <button
            onClick={() => scrollTo("offer")}
            data-testid="hero-weekly-special-badge"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#E05947] text-white text-sm tracking-wide font-medium shadow-lg shadow-[#E05947]/40 hover:scale-105 transition-transform animate-[pulse_2.4s_ease-in-out_infinite]"
          >
            <Flame size={16} /> Weekly Special — see this week's pick
          </button>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/70 text-xs tracking-[0.3em] uppercase">
        Scroll
      </div>
    </section>
  );
}
